@if (folderFormId || folderFormData) {
    <div class="gaps-between-sections">
        <div class="grid-2col input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.opz.destination' | translate }}</div>
            @for (key of ['transportWhere', 'contactPersonOfWorkplace']; track key) {
                <app-text-input
                    [id]="key"
                    [form]="form"
                    [label]="'form.opz.fields.' + key"
                ></app-text-input>
            }

            <app-date-input
                id="dateOfContract"
                [form]="form"
                label="form.opz.fields.dateOfContract"
            ></app-date-input>

            <div></div>

            @for (key of ['completionOfExistingHistory', 'allergy']; track key) {
                <app-text-input
                    [id]="key"
                    [form]="form"
                    [label]="'form.opz.fields.' + key"
                ></app-text-input>
            }
        </div>

        <div class="grid-2col input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.opz.lastSubmission' | translate }}</div>
            @for (key of ['medicals', 'food', 'insulin', 'lastWoundDressing', 'lastStool', 'other']; track key) {
                <app-text-input
                    [id]="key"
                    [form]="form"
                    [label]="'form.opz.fields.' + key"
                ></app-text-input>
            }
        </div>

        <div class="grid-1col input-grid-gaps">
            <div class="font-bold">{{ 'form.opz.confirmationOfHandover' | translate }}</div>
            @for (key of ['insuranceCard', 'idCard', 'incontinenceAids']; track key) {
                <app-check-input
                    [id]="key"
                    [form]="form"
                    [label]="'form.opz.fields.' + key"
                ></app-check-input>
            }

            <app-text-input
                id="amountOfIncontinenceAids"
                [form]="form"
                label="form.opz.fields.amountOfIncontinenceAids"
            ></app-text-input>

            @for (key of ['medicalDocumentation', 'toiletries', 'medicalsBool', 'insulinBool', 'glasses']; track key) {
                <app-check-input
                    [id]="key"
                    [form]="form"
                    [label]="'form.opz.fields.' + key"
                ></app-check-input>
            }

            <app-text-input
                id="otherThings"
                [form]="form"
                label="form.opz.fields.otherThings"
            ></app-text-input>
        </div>

        <div class="grid-4col input-grid-gaps">
            <div class="font-bold">{{ 'form.administration' | translate }}</div>
            <app-text-area-input
                id="note"
                [form]="form"
                label="form.opz.fields.note"
                class="fr-4"
            ></app-text-area-input>

            <app-select-input
                [form]="form"
                id="user"
                [infiniteScroll]="store.userScroll()"
                valueKey="id"
                label="form.opz.fields.user"
            >
                <ng-template #item let-item>
                    {{ item | formatPerson }}
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item | formatPerson }}
                </ng-template>
            </app-select-input>
            <app-date-input
                id="date"
                [form]="form"
                label="form.opz.fields.date"
            ></app-date-input>
        </div>

        <app-action-buttons
            [primaryButtonVisibility]="form.enabled"
            (primaryClickEvent)="submit()"
            (secondaryClickEvent)="closeForm.emit()"
        ></app-action-buttons>
    </div>
}
